import { createAsyncThunk } from '@reduxjs/toolkit';
import { validateAirline } from '@/libs/validation/validateAirline';
import { FlightField } from './interface';
import { flightsActions } from './index';
export const setFlightAirline = createAsyncThunk('flights/setFlightAirline', async ({ _uuid, value, code }, thunkApi) => {
    const isValueInList = Boolean(code);
    const { error } = await validateAirline(value, { isValueInList });
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.airline,
        value,
    }));
    thunkApi.dispatch(flightsActions._setFlightCode({
        _uuid,
        field: 'airlineCode',
        code,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.airline,
        error,
    }));
});
